import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LocalStorageService {

  constructor() { }

  set(item: string, consultor: string) {
    localStorage.setItem(item, consultor);
  }

  get(item: string) {
    const session = localStorage.getItem(item);
    // console.log('session', session);
    if (!session) {
      return session;
    }
    return session;
  }

  clear() {
    localStorage.clear();
  }

}
